import { Link } from "@mui/material";
import moment from "moment";

import {
  HorizontalContainer,
  SectionHeader,
  SectionTitle,
  ShowLabel,
  ShowValue,
  WorkspacePanel,
  WorkspaceSection,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";

import { InfoIcon } from "../Svg";

import { colors } from "../../styles/colors";

const formatDateValue = (value: any) => {
  if (!value) {
    return "-";
  }

  return moment(value).isValid()
    ? moment(value).format("DD/MM/YYYY hh:mm A")
    : value;
};

const formatBooleanValue = (value: any) => {
  if (typeof value === "boolean") {
    return value ? "YES" : "NO";
  }

  if (typeof value === "string") {
    const normalizedValue = value.trim().toLowerCase();

    if (["true", "yes", "verified"].includes(normalizedValue)) {
      return "YES";
    }

    if (["false", "no", "not_verified", "not verified"].includes(normalizedValue)) {
      return "NO";
    }

    return value;
  }

  if (typeof value === "number") {
    return value ? "YES" : "NO";
  }

  return "-";
};

const CFPMenuIngredientStatus = ({ record }: { record: any }) => {
  return (
    <WorkspacePanel>
      <WorkspaceSection>
        <SectionHeader>
          <WorkSpaceTitleRow>
            <InfoIcon color={colors.primary} width={16} height={16} />
            <SectionTitle>Menu & Ingredient Status</SectionTitle>
          </WorkSpaceTitleRow>
        </SectionHeader>
      </WorkspaceSection>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>Menu Finalized On:</ShowLabel>
        <ShowValue>
          {record?.menuFinalisedAt
            ? formatDateValue(record?.menuFinalisedAt)
            : "Not Available"}
        </ShowValue>
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>
          Ingredients Verified:
        </ShowLabel>
        <ShowValue>
          {record?.isIngredientListVerified !== undefined &&
          record?.isIngredientListVerified !== null
            ? formatBooleanValue(record?.isIngredientListVerified)
            : "Not Available"}
        </ShowValue>
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>Ingredients Verified On:</ShowLabel>
        <ShowValue>
          {record?.ingredientListLastVerifiedAt
            ? formatDateValue(record?.ingredientListLastVerifiedAt)
            : "Not Available"}
        </ShowValue>
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>Verified By:</ShowLabel>
        {record?.ingredientListVerifiedBy ? (
          <Link
            href={
              record?.ingredientListVerifiedByType === "ADMIN"
                ? `/#/AdminUsers/${record?.ingredientListVerifiedBy}/show`
                : `/#/Cooks/${record?.ingredientListVerifiedBy}/show`
            }
          >
            {record?.ingredientListVerifiedBy}
          </Link>
        ) : (
          <ShowValue>Not Available</ShowValue>
        )}
      </HorizontalContainer>
      <HorizontalContainer style={{ marginBottom: "8px" }}>
        <ShowLabel style={{ marginBottom: "0px" }}>
          Verified By (Role):
        </ShowLabel>
        <ShowValue>{record?.ingredientListVerifiedByType || "Not Available"}</ShowValue>
      </HorizontalContainer>
    </WorkspacePanel>
  );
};

export default CFPMenuIngredientStatus;
